/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';
import { BeatLoader } from 'react-spinners';
import styled from 'styled-components';
import logo from '../img/minhalogo.svg';

function Loading(props) {
  const Container = styled.main`
        background-color: #020202;
        width: 100vw;
        height: 100vh;
        display: flex;
        text-align: center;
        justify-items: center;
        justify-content: center;
    `;

  const Div = styled.div`
        display: flex;
        flex-direction: column;
        margin: auto;
    `;

  const Img = styled.img`
        justify-content: center;
        justify-items: center;
        margin: 1.5rem 0;
    `;

  return (
    <Container>
      <Div>
        <Img src={logo} alt="logo Murilo Cardoso dos Santos" />
        <BeatLoader
          loading={props.loading}
          color="#57886c"
          size={20}
          speedMultiplier={1}
        />
      </Div>
    </Container>
  );
}

export default Loading;
